export * from './account-product-short.slice';
